import { render, staticRenderFns } from "./Processamentos.vue?vue&type=template&id=ec0dd060"
import script from "./Processamentos.vue?vue&type=script&lang=js"
export * from "./Processamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports